export default __webpack_public_path__ + "static/media/edms-demo-2.73a73386.mp4";